// Central definition of capacity-status colours.
// Both the 12-week overview table and the week detail modal import from here
// so the same issue is highlighted with the same colour in both places.
//
// Design: three headcount levels read as a calm traffic light
// (surplus = green, adequate = amber, shortage = red); on-call-on-leave is a
// categorically different flag, so it gets its own hue (violet) rather than a
// third warm colour that would clash with red/amber. All fills share the same
// soft weight (-200) so no single status looks louder than the others.
//   table  – solid fill for overview cells and the modal's status header
//   soft   – faint tint for the modal day-block background
//   border – matching border for the soft block
//   number – text colour for the staffing figure
//   dot    – legend swatch
export const STATUS_STYLES = {
  surplus: {
    label: 'Surplus',
    table: 'bg-emerald-200 text-emerald-900',
    soft: 'bg-emerald-50',
    border: 'border-emerald-300',
    number: 'text-emerald-900',
    dot: 'bg-emerald-200 border-emerald-400',
  },
  shortage: {
    label: 'Adequate',
    table: 'bg-amber-200 text-amber-900',
    soft: 'bg-amber-50',
    border: 'border-amber-300',
    number: 'text-amber-900',
    dot: 'bg-amber-200 border-amber-400',
  },
  critical: {
    label: 'Shortage',
    table: 'bg-red-200 text-red-900',
    soft: 'bg-red-50',
    border: 'border-red-300',
    number: 'text-red-900',
    dot: 'bg-red-200 border-red-400',
  },
  oncall_leave: {
    label: 'On-Call on Leave',
    table: 'bg-violet-200 text-violet-900',
    soft: 'bg-violet-50',
    border: 'border-violet-300',
    number: 'text-violet-900',
    dot: 'bg-violet-200 border-violet-400',
  },
};

// `adequate` shares the green "all good" treatment with surplus.
export const getStatusStyle = (status) => STATUS_STYLES[status] || STATUS_STYLES.surplus;
